
<nav class="w-full h-20 bg-white dark:bg-zinc-900 shadow-lg">
  <div class="w-full h-20 p-4 gap-4 lg:p-4 flex items-center justify-between">
    <div class="flex items-center gap-4 lg:gap-8">
      <div class="block lg:hidden cursor-pointer" variant="text" (click)="toggleMenuDrawer()">
        <i class="fa-solid fa-bars"></i>
      </div>
      <h1 class="text-2xl font-semibold text-zinc-900">{{ title() }}</h1>
      <ng-content />
    </div>
    <div class="flex items-center gap-4">
<!--      <div>-->
<!--        <p-button (click)="toggleDarkMode()" variant="text" severity="contrast" rounded>-->
<!--          <ng-template #icon>-->
<!--            <lucide-angular [img]="(isDarkMode() | async) ? moonIcon : sunIcon"></lucide-angular>-->
<!--          </ng-template>-->
<!--        </p-button>-->
<!--      </div>-->
      @if (user()) {
        <div class="flex items-center gap-4 cursor-pointer" (click)="menu.toggle($event)">
          <div class="text-end">
            {{ user()?.name }}
          </div>
          <p-avatar [image]="'https://ui-avatars.com/api/?rounded=true&bold=true&name=' + user()?.name" size="large" shape="circle" />
        </div>
        <p-menu #menu [model]="avatarMenuItems" [popup]="true" appendTo="body">
          <ng-template #item let-item>
            <a pRipple class="flex items-center p-menu-item-link" (click)="onAvatarMenuItemClick(menu, item, $event)">
              <i [class]="item.icon + ' text-zinc-700 dark:text-zinc-400'"></i>
              <span class="text-zinc-900 dark:text-white">{{ item.label }}</span>
            </a>
          </ng-template>
        </p-menu>
      }
    </div>
  </div>
</nav>
